module.exports = __webpack_public_path__ + "static/shoes-color-set-4-bcfe79423c7f6907b7771ea89b6b0299.png";